import Vue from 'vue';

const JS_SRC = 'https://www.google.com/recaptcha/api.js?render=<RECAPTCHA_V3_KEY>';

function _attachToDom(recaptchaV3Key) {
  const scriptEl = document.createElement('script');
  scriptEl.src = JS_SRC.replace('<RECAPTCHA_V3_KEY>', recaptchaV3Key);
  document.body.appendChild(scriptEl);
}

class RecaptchaHelper {
  constructor() {
    this._isAttached = false;
    this._isV2Rendered = false;
  }

  getTokenV2() {
    if (!window.grecaptcha) {
      Vue.prototype.$errorHandler.log('getTokenV2: grecaptcha not present.');
      return null;
    }

    return window.grecaptcha.getResponse();
  }

  async getTokenV3(recaptchaV3Key) {
    if (!recaptchaV3Key) {
      Vue.prototype.$errorHandler.log('getTokenV3: V3 key not set.');
      return null;
    }

    if (!window.grecaptcha) {
      Vue.prototype.$errorHandler.log('getTokenV3: grecaptcha not present.');
      return null;
    }

    try {
      const token = await window.grecaptcha.execute(
        recaptchaV3Key,
        { action: 'login' },
      );
      return token;
    } catch (error) {
      Vue.prototype.$errorHandler.log(`getTokenV3: ${ error.toString() }`);
      return null;
    }
  }

  renderV2(element, recaptchaV2Key) {
    if (!element
      || !recaptchaV2Key
      || this._isV2Rendered
      || !this._isAttached) {
    return;
    }

    if (!window.grecaptcha || !window.grecaptcha.render) {
      setTimeout(() => {
        this.renderV2(element, recaptchaV2Key);
      }, 100);

      return;
    }

    window.grecaptcha.render(
      element,
      {
        'sitekey': recaptchaV2Key,
      },
    );

    this._isV2Rendered = true;
  }

  setup(recaptchaV3Key) {
    if (!recaptchaV3Key) {
      Vue.prototype.$errorHandler.log('Recaptcha setup: no V3 key.');
      return false;
    }

    if (this._isAttached) {
      return false;
    }

    _attachToDom(recaptchaV3Key);
    this._isAttached = true;
    return true;
  }
}

export default new RecaptchaHelper();
